module.exports = __webpack_public_path__ + "static/img/2_1_2_3.3be25fc9.jpg";